<template>
  <div class="main">
    <top-header :type="5" placeholder="" :bgColor="'#161616'" :textColor="'#fff'" />
    <swiper class="swiper" :options="swiperOptionh" ref="mySwiper">
      <swiper-slide v-if="videoArr.length">
        <swiper class="swiper vertical" :options="swiperOptionv">
          <swiper-slide class="slide_video_con" v-for="(item, index) in videoArr" :key="index">
            <p>{{item.bt}}</p>
            <video controls :poster="imgPath + 'sVideo/' + item.imgId + '.jpg'">
              <source :src="imgPath + 'sVideo/' + item.fileName + '.' + item.suffix">
            </video>
          </swiper-slide>
        </swiper>
      </swiper-slide>
      <swiper-slide v-for="(item, index) in photoArr" :key="index">
        <swiper :options="swiperOptionv" class="swiper vertical" v-if="item.imgList.length">
          <swiper-slide class="slide_video_con" v-for="(inner, ind) in item.imgList" :key="ind">
            <p>{{inner.ms ? inner.ms : inner.name}}</p>
            <img :src="imgPath + (item.code == 'A04A09' ? 'sImgHouse/' : 'sImgMax/') + inner.imgid + '.jpg'" alt="">
            <p class="tips" v-show="item.code != 'A04A09'">以上图片为示意图，与实景可能存在一定差异，如有变化不在另行通知，具体以开发商实际交付为准。</p>
          </swiper-slide>
        </swiper>
        <swiper :options="swiperOptionv" class="swiper vertical" v-if="!item.imgList.length">
          <swiper-slide class="slide_video_con">
            <p>{{item.name}}</p>
            <img src="@/assets/img/default_house_list.jpg" alt="">
          </swiper-slide>
        </swiper>
      </swiper-slide>
    </swiper>
    <div class="tab_com">
      <swiper :options="tabOption" ref="tabOptions">
        <swiper-slide v-if="videoArr.length" @click.native="toSlide(0)">视频({{videoArr.length}})</swiper-slide>
        <swiper-slide v-for="(item, index) in photoArr" :key="index" @click.native="toSlide(videoArr.length ? index + 1 : index)">{{item.name}}({{item.imgCount}})</swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
export default {
  data() {
    return {
      swiperOptionh: {
        on: {
          slideChangeTransitionEnd: (data) =>{
            this.topSwiperIndex = data.activeIndex;
            this.$refs.tabOptions.$swiper.slideTo(data.activeIndex, 100);
          },
        },
        observer:true,
        observeParents:true,
      },
      swiperOptionv: {
        observer:true,
        observeParents:true,
      },
      tabOption: {
        on: {
          slideChangeTransitionEnd: (data) =>{
            this.topSwiperIndex = data.activeIndex;
            this.$refs.mySwiper.$swiper.slideTo(data.activeIndex, 100);
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 30,
        centeredSlides: true,
      },
      photoArr: [],
      videoArr: [],
      innerSwiperIndex: 1,
      totalText: 0,
      topSwiperIndex: 0
    };
  },
  components: {
    topHeader,
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.getAll();
    // this.getVideo()
  },
  methods: {
    pauseAll(index){
      if(this.videoArr.length) {
        var videos = document.getElementsByTagName('video');
        for (var j = videos.length - 1; j >= 0; j--) {
          if (j!=index){
            videos[j].pause();
            videos[j].load();
          }
        }
      }
    },
    getVideo() {
      return new Promise((resolve) => {
        this.$new.post('itemInfo/getItemVideoById.do', qs.stringify({
          itemId: this.$route.query.itemId || '7c2bf0da11494dd798cc447dc3cb2cc8'
        })).then(res => {
          if(res.success) {
            this.videoArr = res.obj || [];
          }
          resolve(res)
        })
      });
    },
    getPhotos() {
      return new Promise((resolve) => {
        this.$new.post('itemInfo/getItemImgById.do', qs.stringify({
          itemId: this.$route.query.itemId || '7c2bf0da11494dd798cc447dc3cb2cc8'
        })).then(res => {
          this.photoArr = res.obj || [];
          resolve(res)
        })
      });
    },
    getAll() {
      Promise.all([this.getVideo(), this.getPhotos()]).then(res => {
        // if(res[0].success) {
        //   this.totalText = res[0].obj.length
        // } else {
        //   this.totalText = res[1].obj[0].imgList.length
        // }
        if(this.$route.query.index) {
          this.$refs.mySwiper.$swiper.slideTo(this.$route.query.index, 100)
        }
      })
    },
    toSlide(index) {
      this.$refs.mySwiper.$swiper.slideTo(index, 100)
    }
  },
};
</script>
<style lang="less" scoped>
.main{
  height: 100vh;
  background-color: #161616;
}
.slide_video_con{
  height: 9.5rem;
  box-sizing: border-box;
  padding-top: 0.95rem;
  p{
    color: #fff;
    font-size: 0.26rem;
    text-align: center;
    margin-bottom: 1.32rem;
  }
  .tips{
      margin-top:0.5rem;
      margin-bottom: 0;
  }
  img, video{
    width: 100%;
    height: 5.63rem;
  }
}
.tab_com{
  padding: 0 0.2rem;
  position: absolute;
  bottom: 0.46rem;
  left: 0;
  right: 0;
  z-index: 9;
  /deep/
  .swiper-slide {
    line-height: 0.5rem;
    color: #909090;
    font-size: 0.26rem;
    text-align: center;
    width: auto;
    padding: 0 0.18rem;
    border-radius: 0.02rem;
    &.swiper-slide-active{
      background-color: #2F2F2F;
      color: #FFF;
    }
  }
}
</style>